var LoyaltyCardType;
(function(LoyaltyCardType) {
    LoyaltyCardType["LUHN"] = "LUHN";
    LoyaltyCardType["UUID"] = "UUID";
})(LoyaltyCardType || (LoyaltyCardType = {}));

export { LoyaltyCardType };
//# sourceMappingURL=cart.js.map
